import React from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { ProductIntro } from './components/ProductIntro';
import { MockupSection } from './components/MockupSection';
export function App() {
  return <main className="min-h-screen w-full bg-[#FAF7F2] overflow-x-hidden selection:bg-[#C4A265] selection:text-white" data-id="element-0">
      <div className="w-full max-w-screen-xl mx-auto flex flex-col items-center" data-id="element-1">
        <HeroSection data-id="element-2" />
        <EmpathySection data-id="element-3" />
        <ProductIntro data-id="element-4" />
        <MockupSection data-id="element-5" />
      </div>

      {/* Simple footer just to close the page nicely */}
      <footer className="w-full py-5 text-center text-[#7A7A7A] text-xs opacity-60" data-id="element-6">
        <p data-id="element-7">© {new Date().getFullYear()} Plan Anti-Pantalla</p>
      </footer>
    </main>;
}